(function () {
  'use strict';

  function initMotionSection(section) {
    if (!section || section.dataset.arsheMotionReady === 'true') return;
    section.dataset.arsheMotionReady = 'true';

    var viewport = section.querySelector('[data-arshe-motion-track]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-arshe-motion-card]'));
    var modal = section.querySelector('[data-arshe-motion-modal]');
    var modalVideo = section.querySelector('.arshe-motion__modal-video');
    var modalTitle = section.querySelector('[data-arshe-motion-modal-title]');
    var modalPrice = section.querySelector('[data-arshe-motion-modal-price]');
    var modalLink = section.querySelector('[data-arshe-motion-modal-link]');
    var muteButton = section.querySelector('[data-arshe-motion-mute]');
    var closeButtons = section.querySelectorAll('[data-arshe-motion-close]');
    var activePreviews = new Set();
    var activeCard = null;
    var lastFocused = null;
    var historyStateAdded = false;
    var previewEnd = 2.5;
    var maxPreviews = window.matchMedia('(max-width: 749px)').matches ? 2 : 3;

    if (!viewport || !modal || !modalVideo || !cards.length) return;

    function getSource(card) {
      return card.getAttribute('data-video-src') || '';
    }

    function releasePreview(card) {
      var video = card.querySelector('[data-arshe-motion-preview]');
      if (!video) return;
      video.pause();
      video.removeAttribute('src');
      video.load();
      video.classList.remove('is-ready');
      activePreviews.delete(card);
    }

    function preparePreview(card) {
      if (activePreviews.has(card) || activePreviews.size >= maxPreviews) return;
      var source = getSource(card);
      var video = card.querySelector('[data-arshe-motion-preview]');
      if (!source || !video) return;

      activePreviews.add(card);
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.preload = 'metadata';
      video.src = source;
      video.load();

      var start = function () {
        if (!activePreviews.has(card)) return;
        video.currentTime = 0;
        video.classList.add('is-ready');
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {
            activePreviews.delete(card);
          });
        }
      };

      if (video.readyState >= 1) start();
      else video.addEventListener('loadedmetadata', start, { once: true });
    }

    function updatePreviewLimit() {
      if (!activeCard) return;
      while (activePreviews.size > maxPreviews) {
        var first = activePreviews.values().next().value;
        if (!first) break;
        if (first !== activeCard) releasePreview(first);
        else break;
      }
    }

    function closeModal() {
      if (!modal.classList.contains('is-open')) return;
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.removeAttribute('poster');
      modalVideo.load();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('arshe-motion-modal-open');
      document.body.classList.remove('arshe-motion-modal-open');
      var announcement = document.getElementById('arsheAnnouncement');
      if (announcement) { announcement.removeAttribute('aria-hidden'); announcement.style.removeProperty('display'); announcement.style.removeProperty('visibility'); announcement.style.removeProperty('opacity'); announcement.style.removeProperty('pointer-events'); announcement.style.removeProperty('height'); announcement.style.removeProperty('min-height'); announcement.style.removeProperty('max-height'); }
      if (historyStateAdded) {
        historyStateAdded = false;
        if (window.history.state && window.history.state.arsheMotionViewer) {
          window.history.back();
        }
      }
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus(); } catch (e) {}
      }
      lastFocused = null;
      activeCard = null;
      muteButton.setAttribute('aria-pressed', 'false');
      muteButton.setAttribute('aria-label', 'Mute video');
      muteButton.textContent = '🔊';
    }

    function openModal(card) {
      var source = getSource(card);
      if (!source) return;

      activeCard = card;
      lastFocused = document.activeElement;
      modalTitle.textContent = card.getAttribute('data-product-title') || '';
      modalPrice.textContent = card.getAttribute('data-product-price') || '';
      modalLink.setAttribute('href', card.getAttribute('data-product-url') || '#');

      var poster = card.querySelector('.arshe-motion__poster');
      if (poster) {
        var posterSrc = poster.currentSrc || poster.getAttribute('src');
        if (posterSrc) modalVideo.setAttribute('poster', posterSrc);
      }

      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();
      /* Viewer playback starts with sound ON. The customer's card tap is the user gesture. */
      modalVideo.muted = false;
      modalVideo.defaultMuted = false;
      modalVideo.volume = 1;
      modalVideo.autoplay = true;
      modalVideo.playsInline = true;
      /* No native media controls. Android/Chromium can paint a transient media
         timeline/control layer over the viewer; the Motion viewer is intentionally
         clean and playback starts directly from the customer's card tap. */
      modalVideo.controls = false;
      modalVideo.setAttribute('autoplay', '');
      modalVideo.setAttribute('playsinline', '');
      modalVideo.setAttribute('webkit-playsinline', '');
      modalVideo.removeAttribute('muted');
      modalVideo.src = source;
      modalVideo.load();

      /* Attempt immediately inside the user's tap gesture, then retry when media is ready. */
      try {
        var immediatePlay = modalVideo.play();
        if (immediatePlay && typeof immediatePlay.catch === 'function') immediatePlay.catch(function () {});
      } catch (e) {}

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('arshe-motion-modal-open');
      document.body.classList.add('arshe-motion-modal-open');
      var announcement = document.getElementById('arsheAnnouncement');
      if (announcement) { announcement.setAttribute('aria-hidden', 'true'); announcement.style.setProperty('display', 'none', 'important'); }
      muteButton.setAttribute('aria-pressed', 'false');
      muteButton.setAttribute('aria-label', 'Mute video');
      muteButton.textContent = '🔊';

      // Back button closes the viewer without changing normal browser navigation.
      if (!historyStateAdded) {
        window.history.pushState({ arsheMotionViewer: true }, '');
        historyStateAdded = true;
      }

      var playFromStart = function () {
        try { modalVideo.currentTime = 0; } catch (e) {}
        modalVideo.muted = false;
        modalVideo.defaultMuted = false;
        modalVideo.volume = 1;
        modalVideo.autoplay = true;
        modalVideo.controls = false;
        modalVideo.removeAttribute('muted');
        var promise = modalVideo.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {
            /* Do not silently switch the viewer to muted mode. If the browser
               blocks audible autoplay, the native video controls remain available. */
          });
        }
      };

      modalVideo.addEventListener('loadeddata', playFromStart, { once: true });
      modalVideo.addEventListener('canplay', playFromStart, { once: true });
      if (modalVideo.readyState >= 2) playFromStart();
      window.setTimeout(playFromStart, 120);
      window.setTimeout(playFromStart, 600);

      var close = modal.querySelector('.arshe-motion__modal-close');
      if (close) close.focus();
    }

    function onCardActivate(card, event) {
      if (event && event.target && event.target.closest && event.target.closest('a')) return;
      openModal(card);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (event) { onCardActivate(card, event); });
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal(card);
        }
      });

      var preview = card.querySelector('[data-arshe-motion-preview]');
      if (preview) {
        preview.addEventListener('timeupdate', function () {
          if (preview.currentTime >= Math.min(previewEnd, Math.max(0.5, (preview.duration || previewEnd) - 0.05))) {
            try { preview.currentTime = 0; } catch (e) {}
          }
        });
        preview.addEventListener('ended', function () {
          try { preview.currentTime = 0; } catch (e) {}
          var promise = preview.play();
          if (promise && typeof promise.catch === 'function') promise.catch(function () {});
        });
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    muteButton.addEventListener('click', function (event) {
      event.stopPropagation();
      modalVideo.muted = !modalVideo.muted;
      modalVideo.volume = 1;
      var muted = modalVideo.muted;
      muteButton.textContent = muted ? '🔇' : '🔊';
      muteButton.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      muteButton.setAttribute('aria-pressed', muted ? 'false' : 'true');
      if (!muted) {
        var promise = modalVideo.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      }
    });

    modalLink.addEventListener('click', function () {
      closeModal();
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.classList.contains('arshe-motion__modal-backdrop')) closeModal();
    });

    window.addEventListener('popstate', function (event) {
      if (modal.classList.contains('is-open') && historyStateAdded) {
        historyStateAdded = false;
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeModal();
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
          preparePreview(card);
          updatePreviewLimit();
        } else {
          releasePreview(card);
        }
      });
    }, {
      root: viewport,
      rootMargin: '0px 180px 0px 180px',
      threshold: [0, 0.45, 0.75]
    });

    cards.forEach(function (card) { observer.observe(card); });

    viewport.addEventListener('scroll', function () {
      // Re-evaluate which cards are dominant after horizontal swipes.
      window.requestAnimationFrame(updatePreviewLimit);
    }, { passive: true });

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.detail && event.detail.sectionId && section.id.indexOf(event.detail.sectionId) !== -1) {
        cards.forEach(releasePreview);
        observer.disconnect();
        closeModal();
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-arshe-motion-section]').forEach(initMotionSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();